<template>
  <f7-page>
    <f7-navbar
      v-if="mostrarNavbarFrm"
      sliding
      no-shadow
      :style="appTheme != null ? appTheme : appTheme1"
    >
      <div class="lefth">
        <f7-link back>
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </div>
    </f7-navbar>
    <!-- Cabecera Formulario -->
    <div class="div-cabeceraFormulario">
      <f7-row class="">
        <f7-col
          v-if="puntoPaletizadoSeleccionado != null"
          width="60"
        >
          <span class="span-texto-gris-14-500"> {{ puntoPaletizadoSeleccionado.DescripcionCorta }} </span>
          <br>
          <span
            v-if="pedidoPlanificadoPuntoPaletizado != null"
            class="span-texto-gris-14-500"
          > {{ `${$t('production.common.associatedSalesOrder').toUpperCase()}: ${pedidoPlanificadoPuntoPaletizado.Pedido}` }}</span>
        </f7-col>
        <f7-col
          v-if="paleEnRetrabajoPuntoPaletizadoSeleccionadoLocal == null"
          width="40"
          class="col-opcionesDerecha"
        >
          <div
            v-if="pedidoPlanificadoPuntoPaletizado == null"
            class="div-btnAsociarPedido seleccionable"
            @click="AbrirPedidosAsignadosConPuntoDePaletizado()"
          >
            <span>{{ $t('production.common.associateSalesOrder').toUpperCase() }}</span>
          </div>
          <div
            v-if="pedidoPlanificadoPuntoPaletizado != null"
            class="div-btnAsociarPedido seleccionable"
            @click="DesasociarPedidoConPunto()"
          >
            <span>{{ $t('production.common.disassociateSalesOrder') }}</span>
          </div>
        </f7-col>
        <f7-col
          v-if="paleEnRetrabajoPuntoPaletizadoSeleccionadoLocal != null"
          width="40"
          class="col-opcionesDerecha"
        >
          <div
            class="div-btnAsociarPedido seleccionable"
            @click="CancelarRetrabajoDePaleAbiertoEnPuntoDePaletizado()"
          >
            <span class="text-align-center">
              {{ $t('production.common.cancelPalletRework').toUpperCase() }}
            </span>
          </div>
        </f7-col>
      </f7-row>
    </div>

    <div class="div-elementoSeparador-90 div-separador" />
    <!-- Fin Cabecera Formulario -->
    <div class="div-frmEdicionSeleccionConfeccionCalibrado">
      <f7-row class="row-elementosFrm">
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('searchEntity.articleFamily.title.family').toUpperCase()"
                :placeholder="$t('searchEntity.articleFamily.placeholder.selectAFamily')"
                :search-text="$t('searchEntity.articleFamily.searchText')"
                :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
                :default-value="familiaDeLaConfeccion"
                :end-point-for-list="obtenerFamiliaArticulos"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventFamiliaArticulosSelected"
              />
            </f7-col>
          </f7-row>

          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('common.product').toUpperCase()"
                :placeholder="$t('searchEntity.article.placeholder.selectAnArticle')"
                :search-text="$t('searchEntity.article.searchText')"
                :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                :default-value="tipoDeProductoPedidoActual"
                :end-point-for-list="obtenerArticuloFamilia"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :disabled="familiaDeLaConfeccion == null"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventArticuloFamiliaSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>

          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('searchEntity.palletType.title.palletType').toUpperCase()"
                :placeholder="$t('searchEntity.palletType.placeholder.palletType')"
                :search-text="$t('searchEntity.palletType.searchText')"
                :search-cancellation-text="$t('searchEntity.palletType.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.palletType.searchNotFoundText')"
                :default-value="tipoDePalePedidoActual"
                :end-point-for-list="obtenerTipoDePale"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventTipoDePaleSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('common.package').toUpperCase()"
                :placeholder="$t('common.package')"
                :search-text="$t('searchEntity.container.searchText')"
                :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                :default-value="tipoDeEnvasePedidoActual"
                :end-point-for-list="obtenerEnvases"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventEnvaseSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('common.brands').toUpperCase()"
                :placeholder="$t('common.brands')"
                :search-text="$t('searchEntity.brand.searchText')"
                :search-cancellation-text="$t('searchEntity.brand.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.brand.searchNotFoundText')"
                :default-value="marcaDelPedidoActual"
                :end-point-for-list="obtenerMarcas"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventMarcaSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                :title="$t('searchEntity.location.title.producedPallesLocation').toUpperCase()"
                :placeholder="$t('common.location')"
                :search-text="$t('searchEntity.location.searchText')"
                :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
                :default-value="ubicacionDestinoPales"
                :end-point-for-list="obtenerUbicaciones"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventUbicacionesSelected"
              />
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
      <div class="div-elementoSeparador-90 div-separador" />
      <div class="div-opcionesActions">
        <f7-row>
          <f7-col
            width="50"
            class="col-izquierdaActions"
          >
            <a
              class="link link-izquierdaActions-2"
              @click="CancelarEdicion()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-derechaActions"
          >
            <a
              class="link link-derechaActions-2"
              @click="ConfirmarEdicion()"
            >
              {{ $t('common.confirm').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
      <!-- Popup Asignación desde Pedido -->
      <f7-popup
        class="pedidosPlanificados-popup"
        :opened="popupPedidosPlanificadosEnPuntoDePaletizado"
        @popup:closed="popupPedidosPlanificadosEnPuntoDePaletizado = false"
      >
        <f7-navbar
          :title="$t('production.common.availableSalesOrders')"
          sliding
          :style="appTheme2"
        >
          <f7-nav-right>
            <f7-link @click="popupPedidosPlanificadosEnPuntoDePaletizado = false">
              {{ $t('common.x') }}
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <FrmPlannedOrdersPalletizingPoint
          :activo="popupPedidosPlanificadosEnPuntoDePaletizado"
          @pedido-establecido="PedidoEstablecidoParaPuntoDePaletizado()"
          @cerrar-frm="popupPedidosPlanificadosEnPuntoDePaletizado = false"
        />
      </f7-popup>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import FrmPlannedOrdersPalletizingPoint from '@/pages/production/traceability/palletizing/FrmPlannedOrdersPalletizingPoint.vue';
import { sleep } from '@/js/utils/sleep';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import ConexionTA, {
  callObtenerArticulos,
  callObtenerFamiliasDeArticulos,
  callObtenerMarcas,
} from '@/js/services/traceability/APITraceability';
import { TipoArticulo } from '@/js/common/enum';

export default {
  name: 'FrmEditionSelectionPreparationCalibration',
  components: {
    UCSearchEntityERP,
    FrmPlannedOrdersPalletizingPoint,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    mostrarNavbarFrm: {
      type: Boolean,
      default: true,
    },
    appTheme: { type: Object, default: null },
  },

  emits: [
    'cerrarFrm',
    'pedidoEstablecido',
    'tipoEnvasadoActualizado',
    'ubicacionPalesProducidosModificada',
    'eliminarPaleParaRetrabajoAsignado',
  ],

  data() {
    return {
      // pedidoPlanificadoActual: null, // Mantiene el pedidoPlanificado que se establece con el ordenPedidoActual.
      tipoEnvasadoElementoProduccionSeleccionadoLocal: null, // Mantiene el tipo de envasadoElementoProduccion (envase, pale, producto....)
      puntoPaletizadoSeleccionado: null,
      lineaProduccionSeleccionada: null,
      tipoDePalePedidoActual: null, // Mantiene el tipo de Pale del Pedido planificado visible.
      tipoDeProductoPedidoActual: null, // Mantiene el tipo de Producto del Pedido planificado visible.
      marcaDelPedidoActual: null,
      tipoDeEnvasePedidoActual: null, // Mantiene el tipo de Producto del Pedido planificado visible.
      familiaDeLaConfeccion: null, // Mantiene la familia del pedido planificado visible.
      cantidadEnvasesPorPalet: 0,
      cambiosEnPedidoAsignadoEnPuntoDePaletizado: false, // Controla si el punto de paletizado esta realizando confecciones de un pedido planificado.
      popupPedidosPlanificadosEnPuntoDePaletizado: false, // Controla la apertura del popup de pedidos.
      pedidoPlanificadoPuntoPaletizado: null, // Mantiene el pedido asignado en el punto de paletizado.
      paleEnRetrabajoPuntoPaletizadoSeleccionadoLocal: null, // Mantiene el posible palé en retrabajo del punto paletizado seleccionado.
      ubicacionDestinoPales: null,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
      'partidaSeleccionada',
      'paleEnRetrabajoPuntoPaletizadoSeleccionado',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'pedidoPlanificadoSeleccionado',
      'tipoEnvasadoElementoProduccionSeleccionado',
    ]),

    appTheme1() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    appTheme2() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    activo(val) {
      if (val != null && val !== false) {
        this.InicializarFrm();
      }
      if (val != null && val === false) {
        this.RestablecerValores();
      }
    },

  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.puntoPaletizadoSeleccionado = { ...this.puntoDePaletizadoSeleccionado };
      this.lineaProduccionSeleccionada = { ...this.lineaDeProduccionSeleccionada };

      if (this.pedidoPlanificadoSeleccionado != null) {
        this.pedidoPlanificadoPuntoPaletizado = { ...this.pedidoPlanificadoSeleccionado };
      }
      if (this.paleEnRetrabajoPuntoPaletizadoSeleccionado != null) {
        this.paleEnRetrabajoPuntoPaletizadoSeleccionadoLocal = { ...this.paleEnRetrabajoPuntoPaletizadoSeleccionado };
      }

      if (this.tipoEnvasadoElementoProduccionSeleccionado != null) {
        this.tipoEnvasadoElementoProduccionSeleccionadoLocal = { ...this.tipoEnvasadoElementoProduccionSeleccionado };
      }

      if (this.tipoEnvasadoElementoProduccionSeleccionadoLocal === null) {
        this.tipoEnvasadoElementoProduccionSeleccionadoLocal = {
          Id: 0,
          Pale: null,
          Articulo: null,
          Envase: null,
          Marca: null,
          EnvasesPorPale: 0,
        };
        // Sol.222038 --> Propone la familia de la partida seleccionada.
        const tempPartidaSeleccionada = { ...this.partidaSeleccionada };
        if (tempPartidaSeleccionada != null) {
          this.familiaDeLaConfeccion = tempPartidaSeleccionada.Partida.Articulo.Familia;
        }
      }
      this.ubicacionDestinoPales = this.puntoPaletizadoSeleccionado.UbicacionPalesProducidos;
      this.EstablecerValoresDelFormulario();
    },

    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.tipoDePalePedidoActual = null;
      this.tipoDeProductoPedidoActual = null;
      this.tipoDeEnvasePedidoActual = null;
      this.marcaDelPedidoActual = null;
      this.cambiosEnPedidoAsignadoEnPuntoDePaletizado = false;
    },

    EstablecerValoresDelFormulario() {
      Log(this, this.EstablecerValoresDelFormulario.name);
      this.tipoDePalePedidoActual = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Pale;
      this.tipoDeProductoPedidoActual = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Articulo;
      this.tipoDeEnvasePedidoActual = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Envase;
      this.marcaDelPedidoActual = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Marca;
      this.cantidadEnvasesPorPalet = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.EnvasesPorPale;
      if (this.familiaDeLaConfeccion === null) {
        this.familiaDeLaConfeccion = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Articulo.Familia;
      }
    },

    ObtenerValoresDelFrm() {
      Log(this, this.ObtenerValoresDelFrm.name);
      this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Pale = this.tipoDePalePedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Articulo = this.tipoDeProductoPedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Envase = this.tipoDeEnvasePedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Marca = this.marcaDelPedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionadoLocal.EnvasesPorPale = this.cantidadEnvasesPorPalet;
    },

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.tipoEnvasadoElementoProduccionSeleccionado = null;
      this.$emit('cerrarFrm');
      this.RestablecerValores();
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);
      this.ObtenerValoresDelFrm();
      if (!this.ValidarTipoEnvasadoFrm()) {
        return;
      }

      this.tipoEnvasadoElementoProduccionSeleccionado = this.tipoEnvasadoElementoProduccionSeleccionadoLocal;
      // Si hay cambios en el pedido asignado emitimos el evento para informar.
      if (this.cambiosEnPedidoAsignadoEnPuntoDePaletizado) {
        this.$emit('pedidoEstablecido');
      }
      this.$emit('tipoEnvasadoActualizado');
      this.$emit('cerrarFrm');

      if (this.puntoPaletizadoSeleccionado.UbicacionPalesProducidos.Id !== this.ubicacionDestinoPales.Id) {
        this.$emit('ubicacionPalesProducidosModificada', this.ubicacionDestinoPales);
      }
      this.RestablecerValores();
    },

    ValidarTipoEnvasadoFrm() {
      Log(this, this.ValidarTipoEnvasadoFrm.name);
      if (this.tipoDePalePedidoActual === null) {
        HiNotification.Toast('Es necesario establecer un tipo de palé');
        return false;
      }

      if (this.tipoDeProductoPedidoActual === null) {
        HiNotification.Toast('Es necesario establecer un producto');
        return false;
      }

      if (this.tipoDeEnvasePedidoActual === null) {
        HiNotification.Toast('Es necesario establecer un tipo de envase.');
        return false;
      }
      return true;
    },

    /*     UbicacionDestinoPalesModificada(objNuevaUbicacion) {
      Log(this, this.UbicacionDestinoPalesModificada.name);
      this.ubicacionDestinoPales = objNuevaUbicacion;
    }, */

    AbrirPedidosAsignadosConPuntoDePaletizado() {
      Log(this, this.AbrirPedidosAsignadosConPuntoDePaletizado.name);
      this.popupPedidosPlanificadosEnPuntoDePaletizado = true;
    },

    PedidoEstablecidoParaPuntoDePaletizado() {
      Log(this, this.PedidoEstablecidoParaPuntoDePaletizado.name);
      const tempPedidoAsignadoEnPunto = { ...this.pedidoPlanificadoSeleccionado };
      this.pedidoPlanificadoPuntoPaletizado = tempPedidoAsignadoEnPunto;
      if (tempPedidoAsignadoEnPunto != null) {
        this.cambiosEnPedidoAsignadoEnPuntoDePaletizado = true;
        this.familiaDeLaConfeccion = tempPedidoAsignadoEnPunto.Producto.Familia;
        this.tipoDePalePedidoActual = tempPedidoAsignadoEnPunto.Pale;
        this.tipoDeEnvasePedidoActual = tempPedidoAsignadoEnPunto.Envase;
        this.marcaDelPedidoActual = tempPedidoAsignadoEnPunto.Marca;
        // Establecemos el Producto despues de asignar la familia para evitar que se resete el control UC
        sleep(100).then(() => {
          this.tipoDeProductoPedidoActual = tempPedidoAsignadoEnPunto.Producto;
        });
      } else {
        this.cambiosEnPedidoAsignadoEnPuntoDePaletizado = true;
        this.tipoDePalePedidoActual = null;
        this.tipoDeProductoPedidoActual = null;
        this.tipoDeEnvasePedidoActual = null;
        this.marcaDelPedidoActual = null;
      }
    },

    DesasociarPedidoConPunto() {
      Log(this, this.DesasociarPedidoConPunto.name);
      this.cambiosEnPedidoAsignadoEnPuntoDePaletizado = true;
      this.pedidoPlanificadoSeleccionado = null;
      this.pedidoPlanificadoPuntoPaletizado = null;
    },

    CancelarRetrabajoDePaleAbiertoEnPuntoDePaletizado() {
      Log(this, this.CancelarRetrabajoDePaleAbiertoEnPuntoDePaletizado.name);
      this.$emit('eliminarPaleParaRetrabajoAsignado');
      this.CancelarEdicion();
    },
    EventFamiliaArticulosSelected(obj) {
      Log(this, this.EventFamiliaArticulosSelected.name);

      this.familiaDeLaConfeccion = obj;
    },
    EventArticuloFamiliaSelected(obj) {
      Log(this, this.EventArticuloFamiliaSelected.name);
      this.tipoDeProductoPedidoActual = obj;
    },
    obtenerFamiliaArticulos() {
      Log(this, this.obtenerFamiliaArticulos.name);
      return callObtenerFamiliasDeArticulos();
    },

    obtenerArticuloFamilia() {
      Log(this, this.obtenerArticuloFamilia.name);
      return ConexionTA.callObtenerArticulosMateriaPrimaDeUnaFamilia(this.familiaDeLaConfeccion.Id);
    },
    EventUbicacionesSelected(obj) {
      Log(this, this.EventUbicacionesSelected.name);
      this.ubicacionDestinoPales = obj;
    },
    obtenerUbicaciones() {
      Log(this, this.obtenerUbicaciones.name);
      return ConexionTA.callObtenerUbicaciones();
    },
    EventEnvaseSelected(obj) {
      Log(this, this.EventEnvaseSelected.name);
      this.tipoDeEnvasePedidoActual = obj;
    },
    obtenerEnvases() {
      Log(this, this.obtenerEnvases.name);
      return callObtenerArticulos({ tipoArticulo: TipoArticulo.Envase });
    },
    EventTipoDePaleSelected(obj) {
      Log(this, this.EventTipoDePaleSelected.name);
      this.tipoDePalePedidoActual = obj;
    },
    obtenerTipoDePale() {
      Log(this, this.obtenerTipoDePale.name);
      return callObtenerArticulos({ tipoArticulo: TipoArticulo.Palet });
    },
    EventMarcaSelected(obj) {
      Log(this, this.EventMarcaSelected.name);
      this.marcaDelPedidoActual = obj;
    },
    obtenerMarcas() {
      Log(this, this.obtenerMarcas.name);
      return callObtenerMarcas();
    },
  },

};
</script>

<style scoped>
.div-frmEdicionSeleccionConfeccionCalibrado {
  margin-top: 30px;
}

.div-cantidadEnvasesPorPale {
  margin: 10px;
}

.input-1 {
  width: 100%;
  padding-top: 21px;
  padding-left: 17px;
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
}

.row-elementosFrm {
  margin-left: 10px;
  margin-right: 25px;
  margin-bottom: 5px;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.div-cabeceraFormulario {
  margin-left: 22px;
  margin-top: 10px;
}

.div-btnAsociarPedido {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-btnAsociarPedido span {
  color: var(--his-kiwi-pulp);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: left;
}

.col-opcionesDerecha {
  text-align: -webkit-right;
  padding-right: 31px;
}
</style>
